/**
 * template管理工具，提供函数可以自定义注册
 */

import FormatPrice from './price';
import FormatDefault from './default';
import FormatDatetime from './datetime';
import FormatEnum from './enum';
import FormatLink from './link';
import FormatDicCode from './dicCode.vue';
import FormatArray from './array.vue';
import FormatHtml from './html.vue';
import FormatImage from './image.vue';

export default function addTableFormat() { }
const Formaters = {
    FormatPrice, // 已废弃
    FormatDefault,
    FormatDatetime,
    FormatEnum,
    FormatLink,
    FormatDicCode,
    FormatArray,
    FormatHtml,
    FormatImage
};

export { Formaters };
